import axios from "axios";
import {API_URL_BASE, TERMS_SLUG, DEFAULT_LANGUAGE} from "./constants";

export default async function getTermsApi (lng: string = DEFAULT_LANGUAGE) {
    return await axios.get(`${API_URL_BASE}${lng}/${TERMS_SLUG}`);
}